import { Icon, getTextCss } from '@taxbit-private/cosmic'
import { Command, CommandItem } from 'cmdk'
import { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

import { MenuCommand } from '../cmdkTypes'

export type CommandItemProps = MenuCommand & ComponentPropsWithoutRef<typeof CommandItem>

export const KCommandItem = ({ label, action, iconName, ...itemProps }: CommandItemProps) => (
  <Item key={label} onSelect={action} {...itemProps}>
    <Icon name={iconName} />
    {label}
  </Item>
)

export const Item = styled(Command.Item)(
  ({ theme }) => `
  padding: ${theme.spacing.m};
  cursor: pointer;
  ${getTextCss(theme)['body-small']};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.s};
`
)
